import script from "./CreateJobFromTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateJobFromTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CreateJobFromTemplate.vue?vue&type=style&index=0&id=96cb7fe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96cb7fe2"]])

export default __exports__